









































































































































































import {Component, Watch, Prop} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Form from '@/components/form-base';
import {Send, DialogForm, FormOverlay} from '@/components/bwaff';
import _ from 'lodash';
import userManagerApi,{UserManagerApi} from '../../user-manager/api';
import DataTable from '@/components/datatable/datatable';
import {debounce} from 'lodash';

import Vnodes from '@/components/helpers/vnode-helper';
import EditAccessPermissionsConstantsMixin from './edit-access-permissions-constants-mixin.vue';
 import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import { FormattersTypes } from '@/services/types/formatter'

const md5 = require('md5');

@Component({
  components: {
    FormOverlay,
    DataTable,
    DialogForm,
    Vnodes,
    HeaderButtons
  }
})
export default class AccessPermissions extends mixins(EditAccessPermissionsConstantsMixin, Form) {
  @Prop({ default: {} })
  data: any;

  userManagerApi: UserManagerApi = userManagerApi;
  showSelectForId:string = null
  
  active: boolean = false;
  loading: boolean = false;
  userPermissions:any = this.getDefaultUserAlc();
  rows: any = [];
  selected: any = '';
  id: any = '';
  search: any = '';
  itemsRelationsObject: any = this.getDefaultItemsRelationsObject();
  pagination = this.getDefaultPagination();
  tab: string = 'campaigns';

  user:any = {};
  activeWorkspace:any = {};

  get dialogContentClass() {
    if (this.userPermissions.accessToExistingItems==='onlySelected') return 'access-permissions-dialog access-permissions-dialog--onlySelected'
    return 'access-permissions-dialog'
  }

  get header() {
    return this.i18n[this.tab]
      ? this.i18n[this.tab].header
      : '';
  }

  show: string = null;

  genDependConstraint(id: string, key: string = id, iconClass: string = '') {
    const h = this.$createElement;

    const dependConstraint = this.dependConstraint(id);

    if(dependConstraint) {
      const forcedPermissions = dependConstraint.forcedPermissions.map((item: any) => {
      const relation = this.itemsRelationsObject[item.category.plural][item.resourceId];
      const accessType = this.access.find((access: any) => access.value === item.accessType).text;

      const title = id === '*'
        ? this.t('{0} because it\'s used by all {1}',
            [accessType, this.i18n[item.category.plural].title.toLowerCase()]
        )
        : this.t('{0} because it\'s used by {1}',
          [accessType, relation.nameFull ? relation.nameFull : relation.name]
        );

      return h('li', {
          style: {
            color: this.$colors.graphite
          }
        }, title)
      });

      const forcedPermissionsUl = h('ul', forcedPermissions);

      const tooltip = h('v-tooltip', {
          attrs: {
            right: 'right',
          },
          props: {
            'open-on-click': true,
            'open-on-hover': false,
            'color':this.$colors.pink,
            'min-width': 300,
            value: this.show === key
          },
          on: {
            input: (event: boolean) => {
              this.show = key;
            }
          }
        }, [
        h('span', {
          slot: 'activator'
        }, ['']),
        h('span', {
            style: {
              color: this.$colors.graphite
            }
          },
          [
          h('ui-icon', {
              style: {
                position: 'absolute',
                right: '8px',
                top: '5px',
              },
              props: {
                size: 13,
                icon: 'fas fa-times',
              },
              on: {
                click: (event: boolean) => {
                  this.show = null;
                }
              }
            },
          ),
          h('div', this.t('Access type should not be lower than')),
          forcedPermissionsUl
        ])
      ]);

      const icon = h('ui-icon', {
        class: [
          'warning-icon',
          iconClass,
          'ml-4 mb-2'
        ],
        props: {
          size: 12,
          color: this.$colors.tangerine,
          icon: 'fas fa-exclamation-triangle',
        },
        on: {
          click: (event: boolean) => {
            this.show = this.show === key
              ? null
              : key;
          }
        }
      });

      return [icon, tooltip];
    }

    return null;
  }

  penClick(item){
    this.showSelectForId = item?.id
  }

  genSelect(x: any) {
    const h = this.$createElement;
    let id = '';
    let items: any[] = [];
    let ref: any = {};
    let refKey: string = null;

    if(typeof x === 'string') {
      id = x;
      x = null;
      items = this.accessAll;
      refKey = `select_${this.tab}_${id}`
      ref = {
        ref: refKey
      };
    } else {
      id = x.id;
      items = this.access;
    }

    const dependConstraint = this.dependConstraint(id);

    if(dependConstraint && this.currentAcl[id]) {
      this.currentAcl[id] = this.fixValue(this.currentAcl[id], dependConstraint.accessType, id);
    }

    let select = h('ui-select', {
      ...ref,
      key: id,
      props: {
        items: items,
        value: this.currentAcl[id] || 'inherit',
        'hide-details': 1,
        mini: true,
        autocomplete: false
      },
      class: 'access-select',
      on: {
        change: (event: string) => {
          let updateModel = false;

          if(dependConstraint) {
            const newEvent = this.fixValue(event, dependConstraint.accessType, id);
            if(newEvent !== event) {
              event = newEvent;
              updateModel = true;
            }
          }

          //redraws is pretty expensive, thats why we need to minimize this factor
          const dependConstraintOld = md5(JSON.stringify(this.dependConstraint(id)));
          this.currentAcl[id] = event;
          if(updateModel) {
            if(x) {
              // @ts-ignore
              select.componentInstance.internalValue = event;
            } else {
              this.currentAcl[id] = null;

              this.$nextTick(() => {
                this.currentAcl[id] = event;
              });
            }
          }

          const dependConstraintNew = md5(JSON.stringify(this.dependConstraint(id)));

          if(x && dependConstraintOld !== dependConstraintNew) {
            let revision = x.revision ? x.revision : 0;
            this.$set(x, 'revision', ++revision);
          }

          this.checkRelatedPermissions(this.currentAcl[id], id);
          this.penClick(null)
        }
      },
    }, []);

    return select;
  }

  compareAccessPriority(value: string, accessType: string) {
    const constraintAccess = this.access.find((item) => item.value === accessType);
    const valueAccess = this.access.find((item) => item.value === value);

    return valueAccess.priority < constraintAccess.priority
      ? 1
      : valueAccess.priority > constraintAccess.priority
        ? -1
        : 0;
  }

  fixValue(value: string, accessType: string, id: string) {
    if (this.compareAccessPriority(value, accessType) === 1) {
      return accessType;
    }

    return value;
  }

  async mounted() {
    const {user,activeWorkspace} = this.data;
    this.$store.commit('loading', true);
    this.activeWorkspace = activeWorkspace;

    if (user && user.id) {
      this.user = user;
      const resp:any = await this.userManagerApi.getMemberPermissions({
        userId: this.user.id,
        workspaceIds: [this.activeWorkspace.id]
      });
      this.userPermissions = {
        ...this.userPermissions,
        ...resp[0]
      }
    }

    if(this.user.role === 'admin'){
      this.active = true;
      return this.$store.commit('loading', false);
    }
    
    this.rows = await this.userManagerApi.getItemsRelations({
      workspaceId:this.activeWorkspace.id
    });

    this.active = true;

    try {
      let cbs: any[] = [];
      _.forOwn(this.rows, (items: any[], key: string) => {
        items.forEach((item: any) => {
          this.itemsRelationsObject[key][item.id] = item;

          const usage = item.uses;

          if(!usage) {
            return;
          }

          _.forOwn(usage, (usageItems: any, usageKey: string) => {
            let entities: any = [];
            let tabsSettings: any = null;

            if(Array.isArray(usageItems)) {
              if(!usageItems.length) {
                return;
              }

              entities = usageItems;
              tabsSettings = this.tabsSettings.find((item) => item.plural === usageKey);
            } else {
              entities = [ usageItems ] ;
              tabsSettings = this.tabsSettings.find((item) => item.single === usageKey);
            }

            entities = entities
              .filter((e: any) => !!e);

            if(entities.length) {
              cbs.push(() => {
                entities.forEach((entity: any) => {
                  let obj = this.itemsRelationsObject[tabsSettings.plural][entity];
                  if(!obj) {
                    return;
                  }

                  let stage = 0;
                  let result: any = (
                    (stage = 1) && obj.depends
                    && (stage = 2) && obj.depends[key]
                  )
                  || [];

                  result.push(item.id);

                  switch(stage) {
                    case 1:
                      obj.depends = {
                        [key]: result
                      }
                      break;
                    case 2:
                      obj.depends[key] = result
                      break;
                  }
                });
              });
            }

          });
        });
      });

      cbs.forEach((cb) => cb());
    } catch(error) {
      console.error('error', error);
    } finally {
      this.$store.commit('loading', false);
    }

  }

  dependConstraint(resourceId: string): any {
    const entityTabsSettings = this.tabsSettings.find((item) => item.plural === this.tab);
    let result = null;

    if(!entityTabsSettings) {
      return null;
    }

    let depends = this.itemsRelationsObject[entityTabsSettings.plural][resourceId]
      && this.itemsRelationsObject[entityTabsSettings.plural][resourceId].depends;

    if(!depends) {
      return null;
    }

    let forcedPermissions: any = [];

    _.forOwn(depends, (value: any[], key: string) => {
      const tabsSettings = this.tabsSettings.find((item) => item.plural === key);

      value.forEach((e: string) => {
        const accessType = this.userPermissions.acl[tabsSettings.single][e];

        if(
          this.userPermissions.acl[entityTabsSettings.single][resourceId] !== 'fullAccess'
          && (accessType === 'reportsOnly' && this.userPermissions.acl[entityTabsSettings.single][resourceId] !== 'readOnly'
          || accessType === 'readOnly')
        ) {
          result = accessType;
          //this.itemsRelationsObject[tabsSettings.plural][e]
          forcedPermissions.push({
            category: tabsSettings,
            resourceId: e,
            accessType: accessType
          });
        }
      });

    });

    return result
      ? {
        accessType: result,
        forcedPermissions: forcedPermissions
      }
      : null;
  }

  fixEntity(accessType: string, resourceId: string, tab: string) {
    const category: string = this.tabsSettings.find((item) => item.plural === tab).single;

    let usage = this.itemsRelationsObject[tab][resourceId] && this.itemsRelationsObject[tab][resourceId].uses
      ? this.itemsRelationsObject[tab][resourceId].uses
      : false;

    if (!usage) {
      return;
    }

    const usageKeys = Object.keys(usage);

    usageKeys.forEach((key: string) => {
      let tabsSettings: any = null;
      let entities: any[] = [];

      if(Array.isArray(usage[key])) {
        entities = usage[key];
        tabsSettings = this.tabsSettings.find((item) => item.plural === key);
      } else {
        entities = [ usage[key]] ;
        tabsSettings = this.tabsSettings.find((item) => item.single === key);
      }

      entities.forEach((entity: any) => {
        if (this.userPermissions.acl[tabsSettings.single][entity] !== 'fullAccess') {
          if (accessType === 'reportsOnly' && this.userPermissions.acl[tabsSettings.single][entity] !== 'readOnly' || accessType === 'readOnly') {
            this.userPermissions.acl[tabsSettings.single][entity] = accessType;
            this.fixEntity(accessType, entity, tabsSettings.plural);
          }
        }
      });
    });
  }

  checkRelatedPermissions(accessType: string, resourceId: string) {
    this.fixEntity(accessType, resourceId, this.tab);
  }

  close() {
    this.$emit('close');
  }

  save() {
    this.userManagerApi.putMemberAcl({
      userId:this.user.id,
    }, {
      ...this.userPermissions,
      workspaceId:this.activeWorkspace.id
    }).then(() =>{
      this.close();
      this.bus.emit('toast-success', this.t('Permissions successfully changed.'));
    })
  }

  get currentAcl() {
    return this.userPermissions.acl[this.tabs_map[this.tab]] || {};
  }

  defaultPFiltersCache:any = {
    campaigns: [],
    trafficSources: [],
    flows: [],
    landings: [],
    offers: [],
    affiliateNetworks: []
  }

  pFiltersCache: any = {...this.defaultPFiltersCache};

  filters(rows: any, key: string) {
    if (rows) {
      return rows.filter((e: any) => e.name.toLowerCase().includes(this.search.toLowerCase()))
    }
  }

  @Watch('search')
  onSearchChanged(value: string, oldValue: string) {
    if(value !== oldValue || (value === '' && this.pFiltersCache[this.tab].length < this.rows[this.tab].length)) {
      this.fillRowsDebounced();
    }
  }

  @Watch('userPermissions.hideProfit')
  onHideProfit(value) {
    if(value===false){
      this.$set(this.userPermissions, 'showConversions', false);
    }
  }

  @Watch('tab')
  tabActive(value: string, oldValue: string) {
    this.updateTabStatus(value);
  }

  @Watch('active')
  onActiveChanged(value: boolean) {
    if(value) {
      this.updateTabStatus(this.tab);
    }
  }

  updateTabStatus(tab: string) {
    if(!this.rows[tab]) {
      return;
    }

    this.search = '';

    this.show = null;

    if(this.pFiltersCache[tab].length !== this.rows[tab].length) {
      this.$set(this.pFiltersCache, tab, this.rows[tab]);
    }
  }

  get fillRowsDebounced() {
    return debounce(this.fillRows, 300);
  }

  fillRows() {
    let value = this.rows[this.tab].filter((e: any) => {
      const name = e.nameFull ? e.nameFull : e.name;
      return name.toLowerCase().includes(this.search.toLowerCase());
    });
    this.$set(this.pFiltersCache, this.tab, value);
  }
}
